/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import { Box, Image, Tooltip } from '@mantine/core';

// I18n
import { useTranslation } from 'react-i18next';

// Types
import { TProduction } from '@global-types/api/api';
import { EProductionQuantityCheck } from '@global-types/api/enum';

// Assets
import OverRangeIcon from '@assets/icons/over-range.svg';

// Styles
import styles from './CellOverrangeStatus.module.css';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
type TCellOverrangeStatusProps = {
	row: TProduction;
};

export const CellOverrangeStatus = ({
	row,
}: TCellOverrangeStatusProps) => {
	/* ******************************** HOOKS ******************************** */
	const { t } = useTranslation();

	/* ******************************** RENDERING **************************** */
	if (!row) return null;

	return (
		<Box className={styles.cell}>
			{row.quantityCheck ===
				EProductionQuantityCheck.OVER_RANGE && (
				<Tooltip label={t('global.overRange')}>
					<Image
						className={styles.imgOverRange}
						src={OverRangeIcon}
					/>
				</Tooltip>
			)}

			{row.quantityCheck ===
				EProductionQuantityCheck.UNDER_RANGE && (
				<Tooltip label={t('global.underRange')}>
					<Image
						className={styles.imgUnderRange}
						src={OverRangeIcon}
					/>
				</Tooltip>
			)}
		</Box>
	);
};
